import axios from "axios";
import { Payout_Service } from "../Url";

export const PartnerPricingdatabystageActions = {
  PARTNER_PRICING_DATA_BY_STAGE_SUCCESS: "PARTNER_PRICING_DATA_BY_STAGE_SUCCESS",
  PARTNER_PRICING_DATA_BY_STAGE_ERROR: "PARTNER_PRICING_DATA_BY_STAGE_ERROR",
};

export function getPartnerPricingDataByStage(props) {
  const { accessToken, partnerFirmId } = props;
  console.log("getPartnerPricingDataByStage its exicuting");
  

  return (dispatch) =>
    axios({
      method: "post",
      // url: `http://localhost:8010/edge-service/partner-payout-service/pricing/partner-pricing/by-stages/${partnerFirmId}`,
      // url: `http://localhost:8301/partner-payout-service/pricing/partner-pricing/by-stages/${partnerFirmId}`,
      url: `${Payout_Service}/pricing/partner-pricing/by-stages/${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch({
           type: PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_SUCCESS,
           payload: response.data.data,
        });
          return response.data.data;
        } else {
          const error = new Error(response.statusText);
          dispatch({
            type: PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_ERROR,
            payload: error.message || "Failed to fetch partner data",
         });
        console.log("error: line 29:", error);
        
          throw error;
        }
      })
      .catch((err) => {
        dispatch({
            type: PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_ERROR,
            payload: err.message || "Failed to fetch partner data",
         });
        console.log("error:line 36:", err);
        if (err.response) {
          console.log("error:line 38:", err);
        }
        return err;
      });
}


export function addPricingStageByPartner(props) {
  const { accessToken, values, partnerFirmId } = props;
   console.log("addPricingStageByPartner its exicuting", values);
   
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        // url: `http://localhost:8301/partner-payout-service/pricing/save/remarks-stages/${partnerFirmId}`,
        url: `${Payout_Service}/pricing/save/remarks-stages/${partnerFirmId}`,
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        data: values,
      });

      if (response.status >= 200 && response.status < 300) {
        console.log("data line67", response.data.data);
        dispatch({
          type: PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_SUCCESS,
          payload: response.data.data,
       });
        return response.data.data; // Return updated data
      } else {
        const error = new Error(response.statusText);
        console.log("error:line 70:", error);
        throw error;
      }
    } catch (err) {
      console.log("error:line 75:", err);
      throw err;
    }
  };
}
